import { lazy } from 'react';
import { Route, Outlet } from 'react-router-dom';

const Dashboard = lazy(() => import('@/pages/prepaid-engine/dashboard'));
const TarifConfiguration = lazy(
  () =>
    import(
      '@/pages/prepaid-engine/tariff-configuration/view-configured-tariffs'
    )
);
const FeatureAccessPanel = lazy(
  () =>
    import('@/pages/prepaid-engine/feature-access-panels/feature-access-panel')
);
const ArrearConfiguration = lazy(
  () => import('@/pages/prepaid-engine/arrear-configuration')
);

const Fppas = lazy(() => import('@/pages/prepaid-engine/fppas'));

const PrepaidEngineRoutes = (
  <Route
    path="prepaid-engine"
    element={<Outlet />}>
    <Route
      index
      element={<Dashboard />}
    />
    <Route
      path="tariff-configuration"
      element={<Outlet />}>
      <Route
        index
        element={<TarifConfiguration />}
      />
    </Route>
    <Route
      path="arrear-configuration"
      element={<ArrearConfiguration />}
    />
    <Route
      path="feature-access-panel"
      element={<FeatureAccessPanel />}
    />
    <Route
      path="fppas"
      element={<Fppas />}
    />
  </Route>
);

export default PrepaidEngineRoutes;
